var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAzote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icone_azote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exports",
    transform: "translate(-89.000000, -386.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Editor-/-bubble_chart",
    transform: "translate(89.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,13.6 C1.4326888,13.6 0,12.1673112 0,10.4 C0,8.6326888 1.4326888,7.2 3.2,7.2 C4.9673112,7.2 6.4,8.6326888 6.4,10.4 C6.4,12.1673112 4.9673112,13.6 3.2,13.6 Z M10.8,16 C9.6954305,16 8.8,15.1045695 8.8,14 C8.8,12.8954305 9.6954305,12 10.8,12 C11.9045695,12 12.8,12.8954305 12.8,14 C12.8,15.1045695 11.9045695,16 10.8,16 Z M11.2,9.6 C8.5490332,9.6 6.4,7.4509668 6.4,4.8 C6.4,2.1490332 8.5490332,0 11.2,0 C13.8509668,0 16,2.1490332 16,4.8 C16,7.4509668 13.8509668,9.6 11.2,9.6 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAzote);
export default __webpack_public_path__ + "static/media/icone_azote.d4ed44fb.svg";
export { ForwardRef as ReactComponent };